// Image switching component for Stereographic animation. Sets intervals and resets based on a slider component value passed down as a prop.

// Imports
import React from 'react';

// Variable initialization
let i=true;

// Image switch class component
export class Stereoimage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {image: this.props.image1};
        console.log('I was initialized')
    }

    // sets up on component mounting
    componentDidMount() {
        // sets time interval for image switches. Will eventually place on a slider for user interaction
        let timeInt = this.props.slideInt;
        
        //Sets up the image switch function to run and re-render every time interval
        this.interval = setInterval(() => {
            if(i == true){
                // if image 1 switch to image 2
                this.setState({image: this.props.image2}); 
            }
            else{
                // if other image set back to image 1
                this.setState({image: this.props.image1});
            }

            i=!i;
            /* log to dev console for troubleshooting
            console.log('I made a switch');
            console.log(i); */
        }, 3000/timeInt);
    }

    // runs on state update (value update from slider)
    componentDidUpdate(slideInt) {
        //clear original interval
        clearInterval(this.interval);

        //start new interval
        this.interval = setInterval(() => {
            if(i == true){
                // if image 1 switch to image 2
                this.setState({image: this.props.image2}); 
            }
            else{
                // if other image set back to image 1
                this.setState({image: this.props.image1});
            }

            i=!i;
            //switches "slider-value" times per second
        }, 1000/this.props.slideInt);
    }

    // clears interval on component unmount for app speed
    componentWillUnmount(){
        clearInterval(this.interval);
    } 

    //function to render class component
    render() {
        return <div>
                    <img src={this.state.image} height="300px" id="stereoImage"/>
               </div>
    }
}